









import { mapActions, mapState } from 'vuex';
import '@adobe/edex/ui/shared/components/header/header';
import { IMS } from '@adobe/edex/ui/shared/config/ims';
import { keyBy } from 'lodash-es';
import { buildLink } from '@adobe/edex/frontend/mixins/i18n';
import * as querystring from 'querystring';
import { RoutePath } from '@adobe/edex/ui/shared/constants';
import '@adobe/edex/ui/shared/components/dialog-next/dialog';

export default {
  components: {},
  methods: {
    ...mapActions('metadata', ['fetchByType']),
    onRequestMetadata({ detail }) {
      this.fetchByType(detail.type);
    },
    updateHeader() {
      Object.assign(this.$el, {
        user: this.member,
        selfIsLoading: this.authLoadingPage,
        products: this.productsByVanity,
        locationPathname: location.pathname,
      });
    },
    onSearch({ detail: { q } }) {
      const search = querystring.stringify({
        q,
      });
      location.href = buildLink(`${RoutePath.search}?${search}`);
    },
  },
  data: () => {
    return {
      imsIsReady: false,
      locationPathname: location.pathname,
    };
  },
  async mounted() {
    this.imsIsReady = await IMS.isReady();
    this.updateHeader();
  },
  updated() {
    this.updateHeader();
  },
  watch: {
    selfIsLoading: 'updateHeader',
    productsByVanity: 'updateHeader',
    member: 'updateHeader',
  },
  computed: {
    ...mapState('member', ['member', 'loading']),
    selfIsLoading() {
      return this.authLoadingPage;
    },
    authLoadingPage() {
      const imsIsLoading = !this.imsIsReady;
      return imsIsLoading || this.loading;
    },
    ...mapState('metadata', ['products']),
    productsByVanity() {
      return keyBy(this.products || [], 'vanityURL');
    },
  },
};
